module.exports = __webpack_public_path__ + "static/media/Banner-Report.c844adfb.png";